var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pageData == "2"
    ? _c("div", { staticClass: "financial-cont" }, [
        _c(
          "article",
          [
            _c("app-bar", {
              attrs: {
                transparent: _vm.$route.meta.transparent || false,
                goback: _vm.$route.meta.goback || false,
                nation: _vm.$route.meta.nation || false,
                home: _vm.$route.meta.home || false
              }
            })
          ],
          1
        ),
        _c("article", { staticClass: "contents" }, [
          _c(
            "div",
            { staticClass: "branch-info" },
            [
              _c("div", { staticClass: "cont-tit" }, [
                _c("h6", [
                  _vm._v(_vm._s(/*영업점 안내*/ _vm.$t("MMAIN-03-01-02-01")))
                ])
              ]),
              _vm.siteCode == _vm.$config.SITECODE_OGHCM && !_vm.isLogin
                ? [
                    _c("div", { staticClass: "box-normal" }, [
                      _c("div", { staticClass: "header" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.operGroupCd + "_지점명")))
                        ])
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*영업시간*/ _vm.$t("MMAIN-03-01-02-13")) +
                                ":"
                            )
                          ]),
                          _c("div", { staticClass: "dec" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MCOM-0000099") +
                                  "~" +
                                  _vm.$t("MCOM-0000103")
                              ) +
                                ", " +
                                _vm._s(_vm.$t("영업시간_" + _vm.siteCode))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*전화*/ _vm.$t("MMAIN-03-01-02-05")) + ":"
                            )
                          ]),
                          _c("div", { staticClass: "dec" }, [
                            _vm._v(
                              _vm._s(_vm.$t("지점별전화번호_" + _vm.siteCode))
                            )
                          ])
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "box-normal" }, [
                      _c("div", { staticClass: "header" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(_vm._s(/*하노이지점*/ _vm.$t("VN2_지점명")))
                        ])
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*영업시간*/ _vm.$t("MMAIN-03-01-02-13")) +
                                ":"
                            )
                          ]),
                          _c("div", { staticClass: "dec" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MCOM-0000099") +
                                  "~" +
                                  _vm.$t("MCOM-0000103")
                              ) +
                                ", " +
                                _vm._s(_vm.$t("영업시간_" + _vm.siteCode))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*전화*/ _vm.$t("MMAIN-03-01-02-05")) + ":"
                            )
                          ]),
                          _c("div", { staticClass: "dec" }, [
                            _vm._v(_vm._s(_vm.$t("지점별전화번호_oghni")))
                          ])
                        ])
                      ])
                    ])
                  ]
                : [
                    _c("div", { staticClass: "box-normal" }, [
                      _c("div", { staticClass: "header" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.operGroupCd + "_지점명")))
                        ])
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*영업시간*/ _vm.$t("MMAIN-03-01-02-13")) +
                                ":"
                            )
                          ]),
                          _c("div", { staticClass: "dec" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MCOM-0000099") +
                                  "~" +
                                  _vm.$t("MCOM-0000103")
                              ) +
                                ", " +
                                _vm._s(_vm.$t("영업시간_" + _vm.siteCode))
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "item" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(
                              _vm._s(/*전화*/ _vm.$t("MMAIN-03-01-02-05")) + ":"
                            )
                          ]),
                          _vm.operGroupCd == "VN2"
                            ? _c("div", { staticClass: "dec" }, [
                                _vm._v(_vm._s(_vm.$t("지점별전화번호_oghni")))
                              ])
                            : _c("div", { staticClass: "dec" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("지점별전화번호_" + _vm.siteCode)
                                  )
                                )
                              ])
                        ])
                      ])
                    ])
                  ]
            ],
            2
          ),
          _vm.initRBF0401P40.dataGrid != null &&
          _vm.initRBF0401P40.dataGrid.length > 0
            ? _c("div", { staticClass: "push-message" }, [
                _c("div", { staticClass: "cont-tit" }, [
                  _c("h6", [
                    _vm._v(
                      _vm._s(/*최종 푸시 메시지*/ _vm.$t("MMAIN-03-01-01-23"))
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "box-normal",
                    on: {
                      click: function($event) {
                        return _vm.goPage("1")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon icon-alarm" }),
                    _vm.lang == "KOR"
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.initRBF0401P40.dataGrid[0].korTitle)
                          )
                        ])
                      : _vm.lang == "ENG"
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.initRBF0401P40.dataGrid[0].engTitle)
                          )
                        ])
                      : _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$htmlDecode(
                                _vm.initRBF0401P40.dataGrid[0].locTitle
                              )
                            )
                          }
                        })
                  ]
                )
              ])
            : _vm._e(),
          _c("div", { staticClass: "exchange-info" }, [
            _c("div", { staticClass: "cont-tit" }, [
              _c("h6", [
                _vm._v(_vm._s(/*환율정보*/ _vm.$t("MMAIN-03-01-02-02")))
              ])
            ]),
            _c(
              "div",
              { staticClass: "box-normal" },
              _vm._l(_vm.RBF0470140.dataGrid, function(data) {
                return _c(
                  "div",
                  { key: data.cnprtCncycd, staticClass: "exchange-item" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "nation",
                        on: {
                          click: function($event) {
                            return _vm.goToDetail(data)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "icon",
                          class: !_vm._.isEmpty(
                            _vm.getNationCode(data.cnprtCncycd)
                          )
                            ? "icon-nation-" +
                              _vm.getNationCode(data.cnprtCncycd)
                            : ""
                        }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(data.cnprtCncycd))
                        ]),
                        _c("span", {
                          staticClass: "amount",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.siteCode == _vm.$config.SITECODE_OGAUC
                                ? _vm.$num(data.dealBaseExrt, 4, true)
                                : _vm.$num(data.dealBaseExrt, null, true)
                            )
                          }
                        })
                      ]
                    ),
                    _c(
                      "div",
                      {
                        class: {
                          up: data.prdayCntstUpdwnRt > 0,
                          down: data.prdayCntstUpdwnRt < 0
                        }
                      },
                      [
                        data.prdayCntstUpdwnRt > 0
                          ? _c("em", [_vm._v("↑")])
                          : _vm._e(),
                        data.prdayCntstUpdwnRt < 0
                          ? _c("em", [_vm._v("↓")])
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$num(Math.abs(data.prdayCntstUpdwnRt))) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            ),
            _vm.siteCode != _vm.$config.SITECODE_OGAUC &&
            _vm.siteCode != _vm.$config.SITECODE_OGMMR &&
            _vm.siteCode != _vm.$config.SITECODE_OGIND &&
            !_vm.isCorporationUser
              ? _c("div", { staticClass: "box-normal" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(
                        _vm._s(
                          /*Mobile OTP ＆ 간편 로그인 서비스*/ _vm.$t(
                            "MMAIN-03-01-02-07"
                          )
                        )
                      )
                    ]),
                    _c("div", { staticClass: "new" })
                  ]),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "item exchange-info-text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            /*휴대폰 인증으로 간편하게 사용할 수 있는 인증 수단 추가*/ _vm.$t(
                              "MMAIN-03-01-02-08"
                            )
                          ) +
                          "! "
                      ),
                      _c("br"),
                      _vm._v(
                        " " +
                          _vm._s(
                            /*KB 글로벌 뱅킹 서비스가 mOTP와 간편 로그인을 지원합니다*/ _vm.$t(
                              "MMAIN-03-01-02-09"
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn sm inline",
                        on: {
                          click: function($event) {
                            return _vm.goPage("2")
                          }
                        }
                      },
                      [_vm._v(_vm._s(/*정보*/ _vm.$t("MMAIN-03-01-01-24")))]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "btn-area" }, [
            _c(
              "button",
              {
                staticClass: "btn icon-round",
                on: {
                  click: function($event) {
                    _vm.pageData = 1
                  }
                }
              },
              [_c("i", { staticClass: "icon icon-undo" })]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }